import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProductType, StockDto } from '@services/dtos'
import { PaginatedQuery } from '@services/api'
import { PaginatedDto } from '@services/extendedType'
import { StockService } from '@services/stockService'

export enum StockTabs {
  Stocks = 0,
  Transactions = 1,
}

export enum StockStatesTabs {
  DCI = 0,
  ProductBatches = 1,
}

export interface StockFilters extends PaginatedQuery {
  productGenericName?: string
  productType?: ProductType
  alertStock?: boolean
}

export interface StockState {
  stocks: PaginatedDto<StockDto>
  loading: boolean
  filters: StockFilters
  activeTab: StockTabs
  activeStocksTab: StockStatesTabs
}

const initialState: StockState = {
  stocks: {
    datas: [],
    totalCount: 0,
  },
  loading: false,
  filters: {
    limit: 20,
    page: 0,
  },
  activeTab: StockTabs.Stocks,
  activeStocksTab: StockStatesTabs.DCI
}

export const getStocks = createAsyncThunk<
  PaginatedDto<StockDto>,
  void
>('stocks/find', async (_, { getState }) => {
  const { filters } = (
    getState() as { stock: StockState }
  ).stock
  return StockService.getAll(filters)
})

export const stockReducer = createSlice({
  name: 'stocks',
  initialState,
  reducers: {
    updateStocksFilters: (
      state,
      action: PayloadAction<Partial<StockFilters>>,
    ) => {
      state.filters = {
        ...state.filters,
        page: 0,
        ...action.payload,
      }
    },
    setActiveTab: (state, action: PayloadAction<StockTabs>) => {
      state.activeTab = action.payload
    },
    resetActiveTab: (state) => {
      state.activeTab = StockTabs.Stocks
    },
    setActiveStocksTab: (state, action: PayloadAction<StockStatesTabs>) => {
      state.activeStocksTab = action.payload
    },
    resetActiveStocksTab: (state) => {
      state.activeStocksTab = StockStatesTabs.DCI
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStocks.fulfilled, (state, action) => {
      state.stocks = action.payload
      state.loading = false
    })
    builder.addCase(getStocks.pending, (state) => {
      state.loading = true
    })
  },
})

export default stockReducer.reducer

export const { updateStocksFilters, setActiveTab, resetActiveTab, setActiveStocksTab, resetActiveStocksTab } = stockReducer.actions
